export default __webpack_public_path__ + "static/neutral-og-image-2734c0f9d09f026c2bfb5ab811c4100f.jpg";